module.exports = __webpack_public_path__ + "img/40.1b973655.jpg";